import React from 'react';
import AppointmentForm from '../../components/AppointmentForm';
import HomeBanner from '../../components/HomeBanner';
import ClientReview from '../../components/ClientReview';
import Certification from '../../components/Certification';
import PersonalizedSection from '../../components/PersonalizedSection';
import PersonalizedCarausel from '../../components/PersonalizedCarausel';
import PersonalizedNutrition from '../../components/PersonalizedNutrition';
import Explore from '../../components/Explore';

const Home = ({ appointmentRef }) => {
  return (
    <>
      <HomeBanner />
      <PersonalizedSection />
      <PersonalizedCarausel />
      <PersonalizedNutrition />
      <Explore />
      <Certification />
      <ClientReview />
      <div ref={appointmentRef}>
        <AppointmentForm />
      </div>
    </>
  );
};

export default Home;
